// extracted by mini-css-extract-plugin
export default {"pre-data-wave":"utilities_pre-data-wave__B6fjm"};